import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const mergeTeamsRoute: InvariantJiraRoute = {
	name: 'eoc-merge-teams',
	path: '/jira/settings/products/ops/merge-teams',
	exact: true,
};
